(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19405],{

/***/ 19405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SellingBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40724);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function SellingBox() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bg)} py-10`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().carBg)}`,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().center)} block md:flex md:items-center md:justify-between`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().briefWrapper)} relative`,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title)} font-normal mb-2 md:mb-9`,
                                children: [
                                    "Exploring",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().highlight)} block font-black`,
                                        children: "Insurance?"
                                    }),
                                    " ",
                                    "Options? Look No Further!"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().brief)} capitalize text-justify pr-5`,
                                children: "At Insure Your Car, we firmly believe that the path to informed decisions begins with thoroughness and honesty. That's why we've teamed up with a diverse range of trusted insurance providers, ensuring that you have access to every possible option. Our user-friendly comparison engine simplifies the process, allowing you to discover the ideal choice in mere minutes."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bannerImage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/insureyourcar/assets/images/car2Opt.png",
                            width: "773",
                            height: "369",
                            alt: "banner"
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 40724:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__3yjG_","carBg":"style_carBg__itKaX","highlight":"style_highlight__nkYeZ","title":"style_title__ZNqiL","brief":"style_brief__XWV5U","briefWrapper":"style_briefWrapper__EZNbX","center":"style_center__6orLU","bannerImage":"style_bannerImage__oaWfZ"};

/***/ })

}]);